export const PageNotFound = () => {
  return (
    <div className="lf:flex lf:size-full lf:flex-1 lf:items-center lf:justify-center">
      <p className="lf:text-title-lg">404</p>
    </div>
  );
};
